/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Button from './index';
import Icon from '../Icon';
import { COLORS } from '../../constants/styles';
import { isFlagler } from '../../constants/brandConfig';

import styles from './index.styl';

const EditBtn = ({ type, accent, className, onClick, disabled }) => {
  const color = accent && 'primary';
  const flaglerColor = accent && 'flaglerPrimary';
  const fill = accent ? COLORS.white : COLORS.sectionTitleFont;
  const currentColor = isFlagler ? flaglerColor : color;

  return (
    <Button
      icon
      type={type}
      disabled={disabled}
      {...{ className, color: currentColor, onClick }}
    >
      <Icon name="edit" style={{ fill }} />
    </Button>
  );
};

EditBtn.defaultProps = {
  type: 'button',
};

EditBtn.propTypes = {
  accent: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CSSModules(EditBtn, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Button/EditBtn.jsx